
import cookie from './cookie'
import bus from './bus'
import StorageFactory from './storage'
import Vue from 'vue'

window.$bus = Vue.prototype.$bus = bus
window.$cookie = Vue.prototype.$cookie = cookie
window.$storage = StorageFactory(localStorage)
